import React, { createContext, useContext, useState, useEffect } from 'react';

const AccountContext = createContext();

export const AccountProvider = ({ children }) => {
  const [accountDetails, setAccountDetails] = useState(() => {
    // Retrieve account details from localStorage if available
    const savedDetails = localStorage.getItem('accountDetails');
    return savedDetails ? JSON.parse(savedDetails) : null;
  });

  useEffect(() => {
    // Store account details in localStorage whenever they change
    if (accountDetails) {
      localStorage.setItem('accountDetails', JSON.stringify(accountDetails));
    } else {
      localStorage.removeItem('accountDetails'); // Clear if null
    }
  }, [accountDetails]);

  return (
    <AccountContext.Provider value={{ accountDetails, setAccountDetails }}>
      {children}
    </AccountContext.Provider>
  );
};

export const useAccount = () => {
  return useContext(AccountContext);
}; 